const Footer = () => {
    return (
      <footer className="bg-gray-100 p-4 w-full"> {/* Tailwind classes */}
        <div className="container mx-auto"> {/* Center content */}
          <p className="text-sm text-gray-600 text-right pr-5">
            Powered by{' '}
            <a href='https://t7e.in/' target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
              T7E
            </a>
          </p>
        </div>
      </footer>
    );
  };
  
  export default Footer;